import React, { useEffect, useState } from 'react';
import { Button, Title } from '@fnacdarty/back-office-ui';
import { Navigate, useNavigate } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import {
	getUser,
	isLoggedIn,
	logout,
} from '../features/authentication/utils/auth';

import { Modal } from '../layouts/index';
import NavBar from '../layouts/NavBar';

const BaseFlexColumn = styled.div`
	display: flex;
	flex-direction: column;
`;
const BaseFlexCenter = styled(BaseFlexColumn)`
	align-items: center;
`;
const BaseFlexStart = styled(BaseFlexColumn)`
	align-items: flex-start;
	width: 100%;
`;
const StyledContainer = styled(BaseFlexCenter)`
	justify-content: flex-start;
	margin: 0px 20px;
	height: calc(100vh - 100px);
	overflow-y: auto;
	width: 40%;
	margin: auto;
	padding: 32px;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		width: 50%;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		width: 70%;
	}
`;
const StyledProfileHeader = styled(BaseFlexCenter)`
	width: 100%;
	margin-top: 20px;
`;
const StyledProfilePicture = styled.div`
	position: relative;
	background-color: #005ead;
	width: 120px;
	height: 120px;
	border: 1px solid white;
	border-radius: 50%;
`;
const StyledInitials = styled.span`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 50px;
	font-weight: bold;
	text-transform: uppercase;
	color: white;
	letter-spacing: 2px;
`;
const StyledDetails = styled(BaseFlexCenter)`
	margin-top: 30px;
	margin-bottom: 10px;
`;

const StyledVersionContainer = styled.div`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.colors.muted};
	font-size: 14px;
	margin-bottom: 20px;
`;

const Settings = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	window.history.pushState({}, '', '/settings');
	const { firstName, lastName, roles = [], username } = getUser();
	const [showModal, setShowModal] = useState(false);
	const [allowedPasswordChange, setChange] = useState(false);

	const confirmLogout = async (response) => {
		if (response) {
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			await logout(() => {});
			window.location.href = '/login';
		}
		setShowModal(false);
	};

	if (!isLoggedIn()) {
		return <Navigate to="/" />;
	}

	const handleHomeRedirect = () => {
		if (isLoggedIn()) {
			navigate('/');
		}
	};

	const isVersionPC = () =>
		window.innerWidth >= `${process.env.REACT_APP_PC_VERSION}`;
	let widthModal = '450px';
	if (!isVersionPC()) {
		widthModal = '350px';
	}

	return (
		<>
			{isVersionPC() && <NavBar />}
			<StyledContainer>
				{showModal && (
					<Modal
						title="Se deconnecter"
						style={{ width: widthModal }}
						onClickCallback={confirmLogout}
					>
						Voulez-vous vraiment vous déconnecter ?
					</Modal>
				)}
				<StyledProfileHeader>
					<StyledProfilePicture onClick={handleHomeRedirect}>
						<StyledInitials>
							{firstName.slice(0, 1)}
							{lastName.slice(0, 1)}
						</StyledInitials>
					</StyledProfilePicture>

					<StyledDetails>
						<Title level={2}>
							{firstName} {lastName}
						</Title>
						<span>{username}</span>
					</StyledDetails>
					<hr />
				</StyledProfileHeader>
				<BaseFlexStart
					style={{ marginBottom: '20px', marginTop: '50px' }}
				>
					<Button
						onClick={() => setShowModal(true)}
						style={{
							backgroundColor: theme.colors.portail,
							fontWeight: 'bold',
						}}
					>
						Se déconnecter
					</Button>
				</BaseFlexStart>
				<BaseFlexCenter>
					<StyledVersionContainer>
						<span>Version {process.env.REACT_APP_VERSION}</span>
					</StyledVersionContainer>
				</BaseFlexCenter>
			</StyledContainer>
		</>
	);
};

export default Settings;
